import { render } from "./range.vue?vue&type=template&id=a67f9828"
import script from "./range.vue?vue&type=script&lang=js"
export * from "./range.vue?vue&type=script&lang=js"

import "./range.vue?vue&type=style&index=0&id=a67f9828&lang=scss&rel=stylesheet%2Fscss"
script.render = render

export default script